import { render, staticRenderFns } from "./SpinnerLoadingUpload.vue?vue&type=template&id=bfb2a120&scoped=true&"
import script from "./SpinnerLoadingUpload.vue?vue&type=script&lang=js&"
export * from "./SpinnerLoadingUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfb2a120",
  null
  
)

export default component.exports